import { useState } from 'react';

import { Divider, Typography, Grid } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { SelectedRoundContainer } from './style';

import SectionSummary from '@components/molecules/cpdEnrollment/confirmAllInformation/sectionSummary';
import { SummarySectionContainer } from '@components/molecules/cpdEnrollment/confirmAllInformation/style';
import { dateFormatThai } from 'src/helpers/utils';
import { ICourse } from 'src/interfaces';

type ProductSelectedCourseAndRoundSummaryProps = {
  coursesRound: CourseRound[];
  regCourses: ICourse[];
};

export type CourseRound = {
  courseId: number;
  roundId: string;
  roundDate: Date;
  expiredDate: Date;
  courseName: string;
  dayAmount: number;
};

const ProductSelectedCourseAndRoundSummary = ({
  coursesRound,
  regCourses,
}: ProductSelectedCourseAndRoundSummaryProps) => {
  const { t } = useTranslation();

  const getCpdProductInfo = (round: CourseRound, index: number) => {
    const dayAmount = `${t('cpd_enrollment.round_date')}: ${round.dayAmount} ${t('cpd_enrollment.day')}`;
    const startDate = `${t('cpd_enrollment.round_start_date')} ${t('cpd_enrollment.round.selected_round_start_date', {
      date: dateFormatThai(round.roundDate),
    })}`;
    const endDate = `${t('cpd_enrollment.round_end_date')} ${t('cpd_enrollment.round.selected_round_end_date', {
      date: dateFormatThai(round.expiredDate),
    })}`;
    return (
      <>
        <Grid item xs={6} md={4}>
          <Typography className="text text-label">
            {index + 1}. {round.courseName}
          </Typography>
        </Grid>
        <Grid item xs={6} md={8}>
          <Typography className="main-info">{dayAmount}</Typography>
          <Typography className="text text-value">{startDate}</Typography>
          <Typography className="text text-value">{endDate}</Typography>
        </Grid>
      </>
    );
  };

  const getRegularProductInfo = (course: ICourse, index: number) => (
    <>
      <Grid item xs={6} md={4}>
        <Typography className="text text-label">
          {coursesRound.length + index + 1}. {course.name}
        </Typography>
      </Grid>
      <Grid item xs={6} md={8}>
        <Typography className="main-info">
          {course.countdown_day === 0
            ? t('home.course_card_can_learn')
            : t('home.course_card_can_learn_have_countdown', { days: course.countdown_day })}
        </Typography>
      </Grid>
    </>
  );
  const renderProductInfos = () => {
    const productInfoElement: JSX.Element[] = [];

    coursesRound.map((round, index) => {
      productInfoElement.push(getCpdProductInfo(round, index));
    });

    regCourses.map((course, index) => {
      productInfoElement.push(getRegularProductInfo(course, index));
    });

    return productInfoElement;
  };

  return (
    <SummarySectionContainer>
      <Typography className="summary-section-title">{t('cpd_enrollment.consent.bundle.product_info.title')}</Typography>
      <Typography className="summary-section-subtitle">
        {t('cpd_enrollment.consent.bundle.product_info.subtitle')}
      </Typography>
      <Divider className="divider" />
      <Grid container alignItems="baseline" columnSpacing={2} rowSpacing={3}>
        {renderProductInfos()}
      </Grid>
    </SummarySectionContainer>
  );
};

export default ProductSelectedCourseAndRoundSummary;
